export default {
  title: '{{plan}} er aktiv',
  plan: 'Abonnement: {{plan}}',
  free_until: 'Gratis indtil {{date}}',
  continue: 'Fortsæt',
};
